import PropTypes from 'prop-types';

function IFDiscoverSomethingNewActive({ className, width }) {
    return (
        <svg className={className} width={width} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.5744 26.0531C16.0088 26.0975 20.3351 25.807 20.3351 25.807C23.9996 25.5 25.371 25.503 25.3026 22.8505C25.3026 22.8505 25.2241 17.8399 24.9919 15.5087C24.8441 14.0489 24.7409 9.64361 24.7409 9.64361C24.7409 9.64361 20.0952 9.93164 18.5443 9.90841C16.0718 9.88246 13.5996 9.98823 11.1383 10.2253L4.5831 10.4899L4.74597 14.3535C4.74597 14.3535 4.7904 16.7131 4.9455 18.9653C5.02221 20.1459 5.14503 23.6967 5.14503 23.6967C5.17844 24.4231 5.49806 25.1067 6.03395 25.5982C6.56984 26.0898 7.27837 26.3492 8.00494 26.3198C8.00494 26.3198 11.8203 26.0049 14.5744 26.0531Z"
                fill="white"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M24.7268 9.6457L4.56529 10.5143L4.50047 8.98036C4.47113 8.25405 4.7306 7.54572 5.22232 7.01038C5.71404 6.47503 6.39784 6.1563 7.12402 6.12394C7.12402 6.12394 12.5171 6.03476 14.3031 5.81593C17.018 5.46056 21.7959 5.49683 21.7959 5.49683C22.5224 5.46748 23.2311 5.7269 23.767 6.21841C24.3029 6.70992 24.6225 7.39356 24.6559 8.11995L24.7268 9.6457Z"
                fill="#DD3D96"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.69369 3.91823L7.87788 8.30769"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.0556 3.35103L21.2396 7.74052"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <mask
                id="path-5-outside-1_5735_1803"
                maskUnits="userSpaceOnUse"
                x="10.8535"
                y="11.912"
                width="8.55901"
                height="11.3996"
                fill="black"
            >
                <rect fill="white" x="10.8535" y="11.912" width="8.55901" height="11.3996" />
                <path d="M18.2992 21.9536L12.6828 22.2449L12.5699 20.0684L14.2961 19.9788L14.106 16.3138L12.7551 16.3839L12.6688 14.7202C13.6268 14.5702 14.1288 14.0926 14.3441 13.1659L16.2079 13.0692L16.5602 19.8614L18.1863 19.7771L18.2992 21.9536Z" />
            </mask>
            <path
                d="M18.2992 21.9536L12.6828 22.2449L12.5699 20.0684L14.2961 19.9788L14.106 16.3138L12.7551 16.3839L12.6688 14.7202C13.6268 14.5702 14.1288 14.0926 14.3441 13.1659L16.2079 13.0692L16.5602 19.8614L18.1863 19.7771L18.2992 21.9536Z"
                fill="#ECE7E4"
            />
            <path
                d="M18.2992 21.9536L18.3251 22.4529C18.6009 22.4386 18.8128 22.2035 18.7985 21.9277L18.2992 21.9536ZM12.6828 22.2449L12.1835 22.2708C12.1978 22.5466 12.4329 22.7585 12.7087 22.7442L12.6828 22.2449ZM12.5699 20.0684L12.544 19.569C12.2682 19.5834 12.0563 19.8185 12.0706 20.0943L12.5699 20.0684ZM14.2961 19.9788L14.322 20.4782C14.5978 20.4639 14.8097 20.2287 14.7954 19.953L14.2961 19.9788ZM14.106 16.3138L14.6054 16.2879C14.5911 16.0121 14.3559 15.8002 14.0801 15.8145L14.106 16.3138ZM12.7551 16.3839L12.2558 16.4098C12.2701 16.6855 12.5052 16.8975 12.781 16.8832L12.7551 16.3839ZM12.6688 14.7202L12.5914 14.2262C12.3384 14.2658 12.1562 14.4903 12.1695 14.7461L12.6688 14.7202ZM14.3441 13.1659L14.3182 12.6665C14.0956 12.6781 13.9075 12.8356 13.8571 13.0527L14.3441 13.1659ZM16.2079 13.0692L16.7072 13.0433C16.6929 12.7675 16.4578 12.5556 16.182 12.5699L16.2079 13.0692ZM16.5602 19.8614L16.0609 19.8873C16.0752 20.1631 16.3103 20.3751 16.5861 20.3608L16.5602 19.8614ZM18.1863 19.7771L18.6857 19.7512C18.6714 19.4754 18.4362 19.2635 18.1604 19.2778L18.1863 19.7771ZM18.2733 21.4543L12.6569 21.7456L12.7087 22.7442L18.3251 22.4529L18.2733 21.4543ZM13.1821 22.219L13.0692 20.0425L12.0706 20.0943L12.1835 22.2708L13.1821 22.219ZM12.5958 20.5677L14.322 20.4782L14.2702 19.4795L12.544 19.569L12.5958 20.5677ZM14.7954 19.953L14.6054 16.2879L13.6067 16.3397L13.7968 20.0047L14.7954 19.953ZM14.0801 15.8145L12.7292 15.8845L12.781 16.8832L14.1319 16.8131L14.0801 15.8145ZM13.2544 16.358L13.1681 14.6943L12.1695 14.7461L12.2558 16.4098L13.2544 16.358ZM12.7462 15.2142C13.2917 15.1287 13.7602 14.9413 14.1261 14.5999C14.4918 14.2585 14.7085 13.8068 14.8311 13.279L13.8571 13.0527C13.7644 13.4516 13.6224 13.7021 13.4438 13.8688C13.2654 14.0352 13.0038 14.1616 12.5914 14.2262L12.7462 15.2142ZM14.37 13.6652L16.2338 13.5685L16.182 12.5699L14.3182 12.6665L14.37 13.6652ZM15.7086 13.0951L16.0609 19.8873L17.0595 19.8355L16.7072 13.0433L15.7086 13.0951ZM16.5861 20.3608L18.2122 20.2764L18.1604 19.2778L16.5343 19.3621L16.5861 20.3608ZM17.687 19.803L17.7999 21.9795L18.7985 21.9277L18.6857 19.7512L17.687 19.803Z"
                fill="#2D2D2D"
                mask="url(#path-5-outside-1_5735_1803)"
            />
        </svg>
    );
}

export default IFDiscoverSomethingNewActive;

IFDiscoverSomethingNewActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

IFDiscoverSomethingNewActive.defaultProps = {
    className: null,
};
